import DAPDetailController from './dap.detail.controller';

export default {
    template: require('./dap.detail.html'),
    controller: DAPDetailController
};
